
import { Vue, Component, Prop } from "vue-property-decorator";
import SectionHeader from "./components/SectionHeader.vue";
import InfoField from "./components/InfoField.vue";
import InfoSection from "./components/InfoSection.vue";
import AllergiesSection from "./components/AllergiesSection.vue";
import AllergyCategory from "./components/AllergyCategory.vue";

@Component({
  components: {
    SectionHeader,
    InfoField,
    InfoSection,
    AllergiesSection,
    AllergyCategory,
  },
})
export default class RisksAndAlerts extends Vue {
  @Prop({ type: Object, required: true }) readonly data!: any;
    @Prop({ type: Object, required: true }) readonly proejctData!: any;
  @Prop({ type: Object, required: true }) readonly currentUser!: object;

  formatAllergies(allergies: string[] | string | null): string[] {
    if (!allergies) return [];

    if (typeof allergies === "string") {
      return allergies.split(",").map((item) => item.trim());
    }

    return allergies;
  }
}
